import { Record } from 'immutable';
import { actionTypes, fetchAppointmentActions, cancelAppointmentActions } from './appointmentDetails.actions';
import * as api from '../../api';

export const AppointmentDetailsState = Record({
  appointment: {
    id: 0,
    title: 'Meeting with Case Manager',
    startDate: new Date(),
    endDate: new Date(),
    staffInvitees: [],
    subjectInvitees: [],
    location: 'Workforce Center',
    description: 'some description of meeting'
  },
  fetch: api.ApiCallState({}),
  cancel: api.ApiCallState({}),
  showCancelModal: false,
  returnToAppointments: false,
});

export const appointmentDetailsReducer = (initialState = new AppointmentDetailsState(), action) => {
  var state = initialState.set('fetch',
    api.apiCallReducer(initialState.get('fetch'), action, fetchAppointmentActions));

  state = state.set('cancel',
    api.apiCallReducer(state.get('cancel'), action, cancelAppointmentActions));

  switch (action.type) {
    case actionTypes.FETCH_APPOINTMENT_SUCCESS:
      return state.set('appointment', action.data.value);
    case actionTypes.CANCEL_APPOINTMENT_SUCCESS:
      return state.set('returnToAppointments', true);
    case actionTypes.FINISH_REDIRECT:
      return state.set('returnToAppointments', false);
    case actionTypes.SHOW_CANCEL_MODAL:
      return state.set('showCancelModal', true);
    case actionTypes.HIDE_CANCEL_MODAL:
      return state.set('showCancelModal', false);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// src/scheduler/appointmentDetails/appointmentDetails.reducer.js